import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CalendarComponent from "../../../components/calendar";
import AppLoader from "../../../components/loader";
import { getfollowUpDates } from "../../../services/ContractApi";
import { handleOpenSnackBar } from "../../../utils/helper";
import { Box } from "@mui/material";

const FollowUpComponent = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [allFollowUpdates, setAllFollowUpDates] = useState(false);
  const searchKeys = useSelector((state) => state.searchKeysReducer.searchKeys);

  useEffect(() => {
    getAllFollowUpDates();
  }, [searchKeys.selectedAgentsForCalendar]);

  const getAllFollowUpDates = async () => {
    setIsLoading(true);
    try {
      const response = await getfollowUpDates(
        searchKeys.selectedAgentsForCalendar
      );
      if (response.data.status === "success") {
        const data = response.data.data;
        const newData = data?.map((x) => ({
          id: x._id,
          type: x.type,
          title: x.userName || "NA",
          businessName: x.businessName || "NA",
          start: new Date(x.followUpDate),
          end: new Date(x.followUpDate),
          followUpDate: new Date(x.followUpDate),
          contractEndDate: x.contractEndDate
            ? new Date(x.contractEndDate)
            : null,
          contact: x.contact || "NA",
          agentName: x.agentName || "NA",
          note: x.note || "NA",
          colorCode: x.agentColorCode,
          allDay: true,
          address: x.address || "NA",
        }));


        setAllFollowUpDates(newData);
      } else {
        handleOpenSnackBar(response.data.message, "error");
      }
    } catch (error) {
      handleOpenSnackBar(error?.message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box>
      <AppLoader isVisible={isLoading} />

      <CalendarComponent
        data={allFollowUpdates || []}
        title={"Follow Up Dates"}
      />
    </Box>
  );
};

export default FollowUpComponent;
